import { adminRecordInspector } from 'rails_routes'
import { type QuotingProspect } from 'utils/web_api.schemas'

export function ProspectOwnerLink ({ prospect }: { prospect: QuotingProspect }) {
  return (
    <a
      aria-label='Owner inspect link'
      href={adminRecordInspector.show({ id: prospect.owner_id })}
      target='_blank'
      rel='noreferrer'
    >
      {prospect.owner_name_or_email}
    </a>
  )
}
